<template>
    <div>
        <div>
            <el-form ref="teacher" :model="$parentInfo.dialog_CreateTeacher.teacher"
                     label-width="70px">
                <el-form-item label="姓名" prop="name">
                    <el-input v-model="$parentInfo.dialog_CreateTeacher.teacher.name" placeholder="请输入姓名" style="width: 200px"></el-input>
                </el-form-item>

                <el-form-item label="性别">
                    <el-radio-group v-model="$parentInfo.dialog_CreateTeacher.teacher.gender_id">
                        <el-radio :label="1">男生</el-radio>
                        <el-radio :label="2">女生</el-radio>
                    </el-radio-group>
                </el-form-item>

                <el-form-item label="手机" prop="studentPhone">
                    <el-input v-model="$parentInfo.dialog_CreateTeacher.teacher.phone" placeholder="请输入联系方式"
                              @change="phoneCheck()" style="width: 200px"
                    ></el-input>
                </el-form-item>

                <el-form-item label="生日">
                    <el-date-picker
                            v-model="$parentInfo.dialog_CreateTeacher.teacher.birthday"
                            type="date"
                            placeholder="请选择学生生日"
                            value-format="yyyy-MM-dd"
                            style="width: 200px">
                    </el-date-picker>
                </el-form-item>

                <el-form-item label="学科">
                    <el-select
                            v-model="$parentInfo.dialog_CreateTeacher.teacher.subject_id"
                            placeholder="请选择学科" style="width: 200px">
                        <el-option
                                v-for="item in $parentInfo.subjects"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="类型选择">
                    <el-select v-model="$parentInfo.dialog_CreateTeacher.teacher.introducation" clearable placeholder="请选择类型" style="width: 200px">
                        <el-option
                                v-for="item in $parentInfo.introducations"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
            </el-form>
        </div>
        <div class="text-right">
            <el-button @click="handleStoreTeacher" :loading="$parentInfo.dialog_CreateTeacher.button_loading">保存
            </el-button>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Dialog_CreateTeacher",
        data() {
            return {
                semester_id:'',
            }
        },
        created() {
            this.$parentInfo = this.$root.$children[0].$refs['dashboard'].$refs[this.$route.path];
        },
        methods: {
            handleStoreTeacher() {
                this.$confirm('确认创建?', '提示', {
                    StartReturn: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.$parentInfo.dialog_CreateTeacher.button_loading = true;
                    this.$wApi.send(this.$parentInfo.path, 'store_teacher', {
                        'name': this.$parentInfo.dialog_CreateTeacher.teacher.name,
                        'gender_id': this.$parentInfo.dialog_CreateTeacher.teacher.gender_id,
                        'birthday': this.$parentInfo.dialog_CreateTeacher.teacher.birthday,
                        'phone': this.$parentInfo.dialog_CreateTeacher.teacher.phone,
                        'subject_id': this.$parentInfo.dialog_CreateTeacher.teacher.subject_id,
                        'introducation': this.$parentInfo.dialog_CreateTeacher.teacher.introducation,
                    });
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消'
                    });
                });
            },
            phoneCheck() {
                if (this.$parentInfo.dialog_CreateTeacher.teacher.phone.length !== 11 || isNaN(this.$parentInfo.dialog_CreateTeacher.teacher.phone) === true) {
                    this.$message({
                        showClose: true,
                        message: '请正确输入手机号',
                        type: 'warning'
                    });
                }
            },
        }
    }
</script>
